interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
}

const Spinner = ({ size = 'medium' }: SpinnerProps) => (
  <div className="flex items-center justify-center relative">
    {/* <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-gray-900"> */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size === 'small' ? '24' : size === 'large' ? '72' : '56'}
      height={size === 'small' ? '24' : size === 'large' ? '72' : '56'}
      viewBox="0 0 56 56"
      fill="none"
      className="animate-spin-slow"
    >
      <circle opacity="0.1" cx="28" cy="28" r="28" fill="black" />
    </svg>

    <div className="absolute animate-spin">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size === 'small' ? '10' : size === 'large' ? '28' : '20'}
        height={size === 'small' ? '10' : size === 'large' ? '28' : '20'}
        viewBox="0 0 20 20"
        fill="none"
      >
        <g opacity="0.3">
          <path
            d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM2.95017 10C2.95017 13.8935 6.10648 17.0498 10 17.0498C13.8935 17.0498 17.0498 13.8935 17.0498 10C17.0498 6.10648 13.8935 2.95017 10 2.95017C6.10648 2.95017 2.95017 6.10648 2.95017 10Z"
            fill="url(#paint0_linear_12189_204605)"
            fillOpacity="0.7"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_12189_204605"
            x1="10"
            y1="0"
            x2="10"
            y2="20"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#666666" />
            <stop offset="1" stopColor="#CCCCCC" />
          </linearGradient>
        </defs>
      </svg>
    </div>
    {/* </div> */}
  </div>
);

export default Spinner;
